import { observable, map, makeObservable } from "mobx"
import SkipLogic from './Models/SkipLogic'
// import $ from 'jquery';
export default class Question {

    // host = ""
    @observable errors = observable.map({})
    @observable skipToPage = observable.map({})
    @observable short_name = ""
    @observable question_text = ""
    @observable instruction_text = ""
    @observable content_text = ""

    page_index = 0
    skip_option_count = 0
    @observable skipGroupIndex = 0

    @observable isEditable = true
    modifiable = true
    @observable mandatory = true
    @observable deletable = true
    @observable visible = true
    

    @observable maximum_number = 2
    @observable minimum_number = 0
    @observable step = 1

    @observable ratingScale

    @observable sets = [
        observable.map({
            xory: "y",
            numCodes: false,
            randomize: false,
            exclusivity: false,
            alpha: false,
            numSort: false,
            options: observable([])
        })
    ]

    @observable langs = observable.map({})
    @observable alignment = "V"
    @observable numeric = false
    @observable alphabetic = false
    @observable israndom = false
    @observable sortnumeric = false
    @observable countries = observable.map({})

    st_text = ""

    @observable language
    @observable tab = "standard"
    @observable isLocked = false
    @observable clientId

    questionRelatedSkipLogic = {}
    optionRelatedSkipLogic = {}

    question_types = [
        { value: "RD", label: "Single Choice", },
        { value: "CH", label: "Multi Choice", },
        { value: "TX", label: "Text box", },
        { value: "TA", label: "Text area", },
        { value: "TB", label: "Grid", },
        { value: "OD", label: "Priority", },
        { value: "PC", label: "Percent", },
        { value: "I", label: "Number range", },
        { value: "RT", label: "Ratings", },
        { value: "CO", label: "Country list", },
        { value: "ST", label: "Static text", },
        { value: "SB", label: "Drop-down list", },
        { value: 'UV', label: 'URL Variable', },
        { value: 'TL', label: 'Text box list', },
        // { value: 'FM', label: 'Form' },
        { value: 'DT', label: 'Date' },
    ]

    rating_options = [
        { value: "0", label: "Please Choose", },
        { value: "2", label: "1-2", },
        { value: "3", label: "1-3", },
        { value: "4", label: "1-4", },
        { value: "5", label: "1-5", },
        { value: "6", label: "1-6", },
        { value: "7", label: "1-7", },
        { value: "8", label: "1-8", },
        { value: "9", label: "1-9", },
        { value: "10", label: "1-10", },
    ]

    @observable question_type = { value: "RD", label: "Single Choice", }
    @observable options = []
    @observable characterLimit = 2000
    @observable wordLimit = 100
    @observable dropDownType
    @observable inheritQuestion = { value: "", label: "" }
    @observable fetchFailed = false
    @observable loading = false
    @observable inheritVisible = false
    @observable pageQuestionMandatory = true

    @observable skipLogic

    /**
     * Advanced
    */
    @observable minNumOptions
    @observable maxNumOptions
    @observable displaycols = 1
    

    text_above = ""
    text_below = ""
    symbol
    @observable maxRankedItems
    /** End Advanced */


    constructor(question, store, survey, ignorePopulate) {
        makeObservable(this)
        // this.validate = this.validate.bind(this)
        // this.removeSkipGroup = this.removeSkipGroup.bind(this)


        this.store = store
        this.skipLogic = new SkipLogic({
            action: {
                kind: 'ShowQuestion',
                pageQuestionId: question.id,

            },
            triggerGroups: [{
                children: [],
                interGroupLogicalOperator: 'OR',
            }],
        }, this.store)
        this.survey = survey
        this.skipLogic.store = store
        this.skipLogic.survey = survey
        this.setLangs(survey, {})

        this.id = question.id
        this.questionId = question.questionId
        this.mandatory = question.mandatory
        if (question.parentId) {
            this.inheritQuestion = { value: question.parentId, label: "" }
        }

        this.deletable = true
        this.isLocked = question.isLocked
        this.oid = this.getQuestionOid(question)
        // this.survey.pageQuestions[question.id] = this

        // this.setDeletable(this.questionId)
        if (!ignorePopulate) {
            this.populate(this.questionId, this.survey, (question, error) => {
                if (!error) {
                    question.skipLogic.action.pageQuestionId = question.id
                    console.log("populated question " + question.questionId)
                    question.setSkipLogic(this.survey, this)
                    if (this.store) {
                        this.survey.questionPopulated(this.store, true)
                    }
                }
            })
        }
    }

    getQuestionOid = (pageQuestion) => {
        const oids = {
            "explori": 1,
            "client": 3,
            "portfolio": 5,
            "product": 6,
            "survey": 7,
            "custom": 8,
        }

        return oids[pageQuestion.questionLevel]
    }

    toJSON = () => {
        const that = this
        let json = {}
        json.langs = this.langs.toJS()
        json.params = {
            
        }
        json.active = true
        json.questionType = this.question_type.value
        json.categoryId = 1234
        json.clientId = 4
        json.mandatory = this.mandatory
        json.reportingOptions = {}
        json.metadata = {
            createdBy: 1234,
            layout: that.layout.value
        }
        json.sets = this.sets.toJS()
        json.isEditable = true,
        json.reportOptions = "some options"
        json.oid = 6
        json.isGlobal = true
        json.benchmark = true
        json.dashboardBarRanges = ""

        switch (json.questionType) {
            case "I":
                    json.params.maxNumber = { value: String(that.maximum_number) }
                    json.params.minNumber = { value: String(that.minimum_number) }
                    json.params.step = { value: String(that.step) }
                break
            case "RD": case "TB":
                json.params.alignment = { value: String(that.alignment) }
                json.params.displaycols = { value: String(that.displaycols) }
                break
            case "CH":
                json.params.alignment = { value: String(that.alignment) }
                json.params.displaycols = { value: String(that.displaycols) }
                json.params.minNumOptions = { value: String(that.minNumOptions) }
                json.params.maxNumOptions = { value: String(that.maxNumOptions) }
                break
            case "TX": case "TA":
                json.params.characterLimit = { value: String(that.characterLimit) }
                json.params.wordLimit = { value: String(that.wordLimit) }
                break
            case "OD":
                json.params.alignment = { value: String(that.alignment) }
                json.params.displaycols = { value: String(that.displaycols) }
                json.params.maxRankedItems = { value: String(that.maxRankedItems) }
                break
            case "RT":
                json.params.ratingScale = { value: String(that.ratingScale.value) }
                json.params.alignment = { value: String(that.alignment) }
                json.params.displaycols = { value: String(that.displaycols) }
                break
            case "CO":
                json.params.dropDownType = { value: String(that.dropDownType.value )}
                json.params.alignment = { value: String(that.alignment) }
                json.params.displaycols = { value: String(that.displaycols) }
                json.params.countries = { value: JSON.stringify(that.countries.toJS()) }
                break
        }

        return json
    }

    updateRatingScale = (obj, survey) => {
        const that = this
        that.ratingScale = obj;
        if (this.sets.length < 2) {
            that.sets.push(observable.map({
                xory: "y",
                numCodes: false,
                randomize: false,
                exclusivity: false,
                alpha: false,
                numSort: false
            }))
        }
        that.sets[1].set("options", observable([]))

        const options = that.sets[1].get("options")
        if (obj) {
            for (let i = 1; i <= obj.value; i += 1) {
                const lang_options = survey.survey_languages.reduce((map, lang) => {
                    map[lang.value] = {
                        text: String(i),
                    }
                    return map
                }, {})
                options.push(observable.map({
                    langs: lang_options,
                    priority: i,
                    params: [],
                    hidden: false,
                    optionOtherIsMandatory: false,
                    hasOptionOther: false
                }));
            }
        }

    }

    setLangs = (survey, langs, override_lang) => {
        const that = this
        survey.survey_languages.forEach((lang_obj) => {
            let T = ""
            let D = ""
            let I = ""
            let A = ""
            let B = ""
            let C = ""

            if (Object.hasOwnProperty.call(langs, lang_obj.value) || override_lang) {
                let lang_code = override_lang || lang_obj.value
                T = langs[lang_code].T.text
                D = langs[lang_code].D.text
                I = langs[lang_code].I.text
                A = langs[lang_code].A.text
                B = langs[lang_code].B.text
                C = langs[lang_code].C.text
            }

            that.langs.set(lang_obj.value, {
                "T" : {
                    "text": T
                },
                "D" : {
                    "text": D
                },
                "I" : {
                    "text": I
                },
                "A" : {
                    "text": A
                },
                "B" : {
                    "text": B
                },
                "C" : {
                    "text": C
                }
            })
        })  
    }

    setSetOptions = (options) => {
        var option_arr = observable([])
        options.forEach((option) => {
            option.params.forEach((param) => {
                option[param.key] = param.value === "true" ? true: false
            
            })
            console.log(JSON.stringify(option))
            option_arr.push(observable.map(option))
        })
        return option_arr
    }

    setSets = (survey, sets) => {
        console.log("setSets " + this.questionId)
        const that = this
        that.sets = []
        sets.forEach((set) => {
            that.sets.push(observable.map({
                xory: set.xory,
                id: set.id,
                questionSetId: set.questionSetId,
                options: that.setSetOptions(set.options),
                numCodes: set.numCodes,
                randomize: set.randomize,
                exclusivity: set.exclusivity,
                alpha: set.alpha,
                numSort: set.numSort
            }))
        })
        console.log("sets done")
    }

    getQuestionData = () => {
        const that = this
        const headers = new Headers({
            authorization: "Bearer " + that.store.token
        });
        return  fetch("http://" + that.store.gateway + "/api/question/" + that.questionId, {
            method: 'GET',
            headers: headers,
            mode: 'cors'
        }).then((res) => {
            return { question: that, data: res.json() }
        })
    }

    populateFromData = (res, survey, questionId, cb) => {
        const that = this
        res = res.question
        that.questionId = questionId
        that.editMode = res.editMode
        that.setLangs(survey, res.langs)
        Object.keys(res.params).forEach((key) => {
            switch (key) {
                case "maxNumber":
                    that.maximum_number = res.params.maxNumber.value
                    break
                case "minNumber":
                    that.minimum_number = res.params.minNumber.value
                    break
                case "step":
                    that.step = res.params.step.value
                    break
                case "displaycols":
                    that.displaycols = res.params.displaycols.value
                    break
                case "minNumOptions":
                    that.minNumOptions = res.params.minNumOptions.value
                    break
                case "maxNumOptions":
                    that.maxNumOptions = res.params.maxNumOptions.value
                    break
                case "characterLimit":
                    that.characterLimit = res.params.characterLimit.value
                    break
                case "wordLimit":
                    that.wordLimit = res.params.wordLimit.value
                    break
                case "maxRankedItems":
                    that.maxRankedItems = res.params.maxRankedItems.value
                    break
                case "alignment":
                    that.alignment = res.params.alignment.value
                    break
                case "ratingScale":
                    that.ratingScale = that.rating_options.find((type) => type.value === res.params.ratingScale.value)
                    break
                case "dropDownType":
                    that.dropDownType = that.dropdown_options.find((type) => type.value === res.params.dropDownType.value)
                    break
                case "countries":
                    that.countries = observable.map(JSON.parse(res.params.countries.value))
                    break
            }
        })
        that.question_type = that.question_types.find((type) => type.value === res.questionType)
        that.setSets(survey, res.sets)
        that.reportingOptions = observable.map(res.reportingOptions)
        that.metadata = observable.map(res.metadata)
        that.isEditable = res.isEditable
        that.oid = res.oid
        that.benchmark = res.benchmark
        that.active = res.active
        that.categoryId = res.categoryId
        that.clientId = res.clientId
        // that.skipLogic.action.pageQuestionId = res.qusetionId
        // that.mandatory = res.mandatory
        that.layout = that.layout_types.find((layout) => layout.value === res.metadata.layout)
        that.default_graph = that.graph_types.find((graph) => graph.value === res.reportingOptions.graphType)
        that.kpi_type = that.kpi_types.find((kpi_type) => kpi_type.value === res.reportingOptions.kpiType)
        that.visible = true
        that.loading = false
        if (cb) {
            // console.log(cb)
            cb(that)
        }
    }

    populate = (questionId, survey, cb) => {
        const that = this
        console.log("populate question " + questionId)
        that.fetchFailed = false
        that.loading = true

        that.store.http.get("/api/question/" + questionId + "/7")
            .then(function(res){
                that.populateFromData(res, survey, questionId, cb)
            }).catch( function(e) {
                console.log(e);
                that.loading = false
                that.store.handleError({ body: e.message, level: 'error' })
                that.errorMsg = e.message
                that.fetchFailed = true
                if (cb) {
                    cb(that, true)
                }
            })
    }

    save = (cb) => {
        const that = this
        const headers = new Headers({
            authorization: "Bearer " + that.store.token,
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
        });
        
        fetch("http://" + that.store.gateway + "/api/question/" + that.questionId, {
            method: 'PUT',
            headers: headers,
            mode: 'cors',
            body: JSON.stringify(that.toJSON())
        }).then((res) => {
            console.log("done " + res)  
            cb()
        }).catch((e) => {
            console.log(e)
        });
    }

    create = (cb, is_new, survey) => {
        const that = this
        console.log("question create " + that.store.gateway)
        const headers = new Headers({
            authorization: "Bearer " + that.store.token,
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
        });
        if (is_new) {
            this.setLangs(survey, this.langs.toJS(), survey.lang.value)
        }
        fetch("http://" + that.store.gateway + "/api/question/", {
            method: 'POST',
            headers: headers,
            mode: 'cors',
            body: JSON.stringify(that.toJSON())
        }).then((res) => {
            const question_id = res.split(" ")[3]
            that.questionId = question_id
            console.log("done " + res)  
            cb()
        }).catch((e) => {
            console.log(e)
        });
    }

    getLabel = (survey) => {
        const lang_code = this.survey.lang.value
        return this.langs.get(lang_code).T.text
    }

    getSkipLabel = (survey, set1, set2) => {
        const lang_code = this.survey.lang.value
        let text
        try {
            text = this.sets[0].get("options").find((option) => option.get("id") === set1).get("langs")[lang_code].text
        } catch (e) {
            console.log("getSkipLabel " + set1)
            console.log(this.sets)
            console.log(JSON.stringify(this.sets[0].toJS(), null, 4))
            throw e
        }
        if (set2) {
            text += " - " + this.sets[1].get("options").find((option) => option.get("id") === set2).get("langs")[lang_code].text
        }
        console.log("getting skiplabel " + this.questionId + " -> " + text)
        return text
    }

    populateSkipGroup = (child, logic, survey) => {
        const that = this;
        child.triggers.forEach((trigger, index) => {
            try {
                console.log("skiprule try " + index + " -> " + trigger.condition.pageQuestionId)
                const pageQuestion = survey.getPageQuestion(null, trigger.condition.pageQuestionId)
                if (!logic.has(trigger.condition.pageQuestionId)) {
                    logic.set(trigger.condition.pageQuestionId, observable.map({
                        label: pageQuestion ? pageQuestion.getLabel(survey) : "",
                        options: observable.map({}),
                    }))
                }
                const skip_question = logic.get(trigger.condition.pageQuestionId)
                let id = trigger.condition.set1
                if (trigger.set2) {
                    id += "|" + trigger.condition.set2
                }
                skip_question.get("options").set(id, (pageQuestion ? pageQuestion.getSkipLabel(survey, trigger.condition.set1, trigger.condition.set2) : ""))
                that.skip_option_count += 1
            } catch (e) {
                console.log("Unable to add skiplogic trigger due to -> " + e)
            }
        })
    }

    setSkipLogic = (survey) => {
        const that = this
        // console.log("populating skiplogic for question " + this.questionId + " -> " + page.id)
        // this.skipLogicId = skip.id
        // this.populateSkipLogic(skip.triggerGroups, survey)
        this.skipLogic.action.pageQuestionId = this.id
        survey.skipLogic.forEach((logic) => {
            if (logic.action.pageQuestionId === that.id) {
                console.log("populated skiplogic for question " + that.questionId + " -> " + logic.id)
                that.skipLogic = new SkipLogic(logic, this.store)
            }
        })
    }

    deleteSkipToPage = () => {
        const that = this
        console.log(`deleteSkipToPage ${this.questionId}`)
        for (const key of this.skipToPage.keys()) {
            const value = that.skipToPage.get(key)
            value.logic.delete()
            that.skipToPage.delete(key)
        }
    }

    validateSkipToPage = (page) => {
        const that = this
        const pages = this.store.survey.getPageIndexes()
        const currPageindex = pages.indexOf(page.id)
        for (const key of this.skipToPage.keys()) {
            const value = that.skipToPage.get(key)
            console.log(`curr ${currPageindex} > ${pages.indexOf(value.logic.action.pageId)} (${value.logic.action.pageId})`)
            if (pages.indexOf(value.logic.action.pageId) <= currPageindex) {
                const targetQuestionObj = value.logic.targetPage.skipToPageTarget[question.questionId]
                console.log(targetQuestionObj)
                if (targetQuestionObj) {
                    const targetPageIndex = targetQuestionObj.indexOf(key)
                    if (targetPageIndex > -1) {
                        targetQuestionObj.splice(targetPageIndex, 1)
                    }
                }
                console.log(targetQuestionObj)
                
                value.logic.delete()
                that.skipToPage.delete(key)
            }
        }
    }

    isInheritable = () => {
        return ["RD", "CH", "CO", "SB"].indexOf(this.question_type.value) > -1
    }

    isMulti = () => {
        return ["RD", "CH", "TB", "OD", "PC", "RT"].indexOf(this.question_type.value) > -1
    }

    changeType = (obj) => {
        const requires_set = ["CH", "OD", "PC", "RD", "RT", "SB"]
        const requires_double_set = ["TB"]
        const question_type_value = obj.value

        this.question_type = obj

        if (question_type_value === "TX") {
            this.wordLimit = 0
            this.characterLimit = 100
        } else if (question_type_value === "TA") {
            this.wordLimit = 0
            this.characterLimit = 2000
        }

        if (requires_set.indexOf(question_type_value) > -1) {
            if (this.sets.length === 0) {
                this.sets = [
                    observable.map({
                        xory: "y",
                        numCodes: false,
                        randomize: false,
                        exclusivity: false,
                        alpha: false,
                        numSort: false,
                        options: observable([])
                    })
                ]
            }
            this.sets.splice(1,1)
        } else if (requires_double_set.indexOf(question_type_value) > -1) {
            const len = this.sets.length
            if (len === 0) {
                this.sets = [
                    observable.map({
                        xory: "y",
                        numCodes: false,
                        randomize: false,
                        exclusivity: false,
                        alpha: false,
                        numSort: false,
                        options: observable([])
                    }),
                    observable.map({
                        xory: "y",
                        numCodes: false,
                        randomize: false,
                        exclusivity: false,
                        alpha: false,
                        numSort: false,
                        options: observable([])
                    })
                ]
            } else if (len < 2) {
                this.sets.push(observable.map({
                        xory: "y",
                        numCodes: false,
                        randomize: false,
                        exclusivity: false,
                        alpha: false,
                        numSort: false,
                        options: observable([])
                    }))
            }
        } else {
            this.sets = []
        }
    }

    addSkipGroup() {
        this.skipLogic.push(observable.map({}))
        this.skipGroupIndex = this.skipLogic.length - 1
    }

    removeSkipGroup(index) {
        this.skipLogic.splice(index, 1)
        if (this.skipLogic.length === 0) {
            this.addSkipGroup()
        }
        if (this.skipGroupIndex >= this.skipLogic.length) {
            this.skipGroupIndex = (this.skipLogic.length - 1)
        }
    }

    validateShortName = (lang_code) => {
        let valid = true
        if (!this.langs.get(lang_code).T.text) {
            valid = false;
        }
        this.errors.set("title", !valid)
        return valid
    }

    validateRating = () => {
        let valid = true
        if (this.question_type.value === "RT" && (!this.ratingScale || this.ratingScale.value === "0")) {
            valid = false
        }
        this.errors.set("rating", !valid)
        return valid
    }

    validateCountries = () => {
        let valid = true
        if (this.question_type.value === "CO" && !this.dropDownType) {
            valid = false
        }
        this.errors.set("country", !valid)
        return valid
    }

    validate(is_new, main_lang_code) {
        const that = this
        let valid = true
        this.errors = observable.map({})
        if (!is_new) {
            this.langs.keys().forEach((lang_code) => {
                valid = valid && that.validateShortName(lang_code)
            })
        } else {
            valid &= that.validateShortName(main_lang_code)
        }
        valid &= that.validateRating()
        valid &= that.validateCountries()
        return valid
    }
}